import type {BoUserGroupEntityType} from '@igp/shared/features/bo-user-group';
import type {TransactionEntityType} from '@igp/shared/features/transaction';
import type {UserProfileEntityType} from '@igp/shared/features/user-profile';

import type {DebtTransferLogEntityType} from '@features/debt-transfer-log';
import type {KeycloakLogEntityType} from '@features/keycloak-log';
import type {ReferralLinkConfigEntityType} from '@features/referral-link-config';

export const EntityType = {
    UserProfile: 'UserProfile' satisfies UserProfileEntityType,
    Transaction: 'Transaction' satisfies TransactionEntityType,
    AgentLevelReporV2: 'AgentLevelReportV2',
    PlayerLevelReportV2: 'PlayerLevelReportV2',
    Country: 'Country',
    BulkOperation: 'BulkOperation',
    AgentProfile: 'AgentProfile',
    NegaitveCarryoverReport: 'NegaitveCarryoverReport',
    NegativeCarryoverWeeklySummary: 'NegativeCarryoverWeeklySummary',
    UserActivitySummary: 'UserActivitySummary',
    PlayerBonus: 'PlayerBonus',
    BonusCode: 'BonusCode',
    Backpack: 'Backpack',
    PlayerReferral: 'PlayerReferral',
    CountryLevelPartnerReport: 'CountryLevelPartnerReport',
    DebtResponsibleMasterAgents: 'DebtResponsibleMasterAgents',
    DebtTransferLog: 'DebtTransferLog' satisfies DebtTransferLogEntityType,
    RepaymentLog: 'RepaymentLog',
    PayoutReport: 'PayoutReport',
    BoUser: 'BoUser',
    BoUserGroup: 'BoUserGroup' satisfies BoUserGroupEntityType,
    P2PPlayerSettings: 'P2PPlayerSettings',
    PlayerEcologyWeekly: 'PlayerEcologyWeekly',
    KeycloakLog: 'KeycloakLog' satisfies KeycloakLogEntityType,
    ReferralLinkConfig: 'ReferralLinkConfig' satisfies ReferralLinkConfigEntityType,
} as const;

export type EntityType = (typeof EntityType)[keyof typeof EntityType];

export const entityTypes = Object.values(EntityType);
